module.exports = __webpack_public_path__ + "img/y_arrow.0e579ff.png";